/**
 * R-2026-08-16: pdfjs-dist 6.x 用 Iterator.prototype.join (ES2025 well-known)。
 * Safari < 17.4 / 旧 Edge 没有 globalThis.Iterator,直接访问 Iterator.prototype 抛 ReferenceError。
 *
 * pdfjs 自己有防御: 检查 Iterator.prototype.join 不是 function 时自 polyfill。
 * 我们只需让 globalThis.Iterator 存在 (空 stub), 触发 pdfjs 的自 polyfill 路径。
 *
 * 兼容性检测:
 *   Chrome 122+ (2024-02)   OK
 *   Firefox 131+ (2024-05)  OK
 *   Safari 17.4+ (2024-03)  OK
 *   旧版                    -> ReferenceError
 *
 * 触发顺序: 必须早于 pdfjs-dist 的 import, 所以放 main.jsx 最顶部。
 */
if (typeof globalThis.Iterator === 'undefined') {
  globalThis.Iterator = function Iterator() {}
  globalThis.Iterator.prototype = {}
}
export {}
